var render = function render(){var _vm=this,_c=_vm._self._c;return _c('surround-box',{attrs:{"title":"秸秆收纳总量"}},[_c('div',{staticClass:"chart-box"},[_c('div',{ref:"chart",staticClass:"chart"}),_c('div',{staticClass:"unit"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }